import React from 'react';
import { Icon } from './Icon.js';
export const IconCameraXmark = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 20L22 6L17 6L15 3L9 3L7 6L2 6L2 20L22 20Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9.25 9.75L12 12.5L14.75 15.25", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M14.75 9.75L12 12.5L9.25 15.25", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCameraXmark.js.map